// extracted by mini-css-extract-plugin
export var border1 = "cL_hz";
export var border2 = "cL_hB";
export var border3 = "cL_hC";
export var border4 = "cL_hD";
export var container = "cL_c";
export var dark = "cL_cy";
export var large = "cL_bZ";
export var ldsRing = "cL_hF";
export var light = "cL_cw";
export var medium = "cL_b0";
export var primaryPressed = "cL_hG";
export var xlarge = "cL_hy";